import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OfbizField } from '../ofbiz-form-model';
import { FormControl } from '@angular/forms';
import { parse } from 'date-fns';
import { NbDatepickerDirective } from '@nebular/theme';

@Component({
  selector: 'ubs-ofbiz-date-picker',
  templateUrl: './ofbiz-date-picker.component.html',
  styleUrls: ['./ofbiz-date-picker.component.scss']
})
export class OfbizDatePickerComponent implements AfterViewInit {
  @Input() formField:OfbizField;
  @Output() setDateField:EventEmitter<any> = new EventEmitter<any>();
  formControl = new FormControl(new Date());

  @ViewChild(NbDatepickerDirective) datePickerDirective!: NbDatepickerDirective<Date>;

  constructor(private cdRef: ChangeDetectorRef) { }
  
  ngAfterViewInit(): void {
    console.log(this.formField)
    if(this.formField.value){
      const rawDate = this.formField.value;
      const cleanedDate = rawDate.split('.')[0];
      const parsedDate = parse(cleanedDate, "yyyy-MM-dd HH:mm:ss", new Date());
      //this.form.controls['date'].setValue(parsedDate); // Set parsed date
      //this.formControl.patchValue(new Date(this.formField.value));
      //this.formControl.setValue(parsedDate);
      /* this.formControl.patchValue(parsedDate);
      this.formControl.updateValueAndValidity();
      this.formControl.markAsTouched(); */
      /* setTimeout(() => {
        this.formControl.setValue(parsedDate);
        this.cdRef.detectChanges(); // Force UI update
      }); */
       // Ensure datepicker UI updates correctly
      setTimeout(() => {
        if (this.datePickerDirective) {
          this.datePickerDirective.writeValue(parsedDate); // Force input update
        }
        this.cdRef.detectChanges(); // Trigger Angular change detection
      });
    }
    console.log(this.formControl)
  }

  dateChange(e){
    this.setDateField.emit(e);
    console.log({DateTracker:e});
  }
}
